/* =========================================================================
   MODA PRAIA 2026 — CARTÃO "FALTA A OUTRA PEÇA DO CONJUNTO" (13/10/2026)

   Lê o estado publicado pela gaveta (snippets/tp-praia-conjunto-carrinho.liquid,
   <script data-tp-praia-conjunto>), refeito a cada mudança do carrinho. Só
   calcinha no carrinho → "Falta o top"; só top → "Falta a calcinha". Cartão
   no rodapé, no desenho do Bazar/Data Dupla, com a gaveta aberta.

   "Escolher o top / a calcinha" abre o POP-UP DE COMPRA RÁPIDA da peça (o
   mesmo "+" dos cards): o cartão carrega os dados da peça num [data-tp-pcf]
   com .tp-pcf__data / .tp-pcf__versao-data e o botão leva [data-tp-qb-open],
   então a delegação global do tp-quick-buy.js faz o resto (inclusive a troca
   alça fina ↔ alta sustentação dentro do pop-up). Ao adicionar, a gaveta
   redesenha, o estado some e o cartão fecha sozinho.

   "Não, obrigada" cala pela sessão, por peça que falta (sessionStorage). O
   cartão da Bolsa de Praia (tp-praia-bolsa.js) espera este sair de cena.

   A OFERTA MANDA: ao abrir avisa (evento tp-oferta-cartao) e os cartões da
   roleta saem de cena.
   ========================================================================= */
(function () {
  if (window.__tpPraiaConjunto) return;
  window.__tpPraiaConjunto = true;

  var raiz = null, timer = null, visto = null, vistoTxt = null;
  function kNao(falta) { return 'tp-pcc-nao:' + (falta || ''); }
  function recusou(falta) { try { return sessionStorage.getItem(kNao(falta)) === '1'; } catch (e) { return false; } }
  function marcarRecusa(falta) { try { sessionStorage.setItem(kNao(falta), '1'); } catch (e) {} }
  function avisar(aberto) { try { document.dispatchEvent(new CustomEvent('tp-oferta-cartao', { detail: { aberto: !!aberto, quem: 'praia-conjunto' } })); } catch (e) {} }
  function gavetaAberta() { return !!document.querySelector('cart-drawer.active, cart-drawer[open]'); }
  function estado() {
    var el = document.querySelector('[data-tp-praia-conjunto]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  /* Para o cartão da bolsa saber se este ainda tem vez. */
  window.__tpPraiaConjuntoPendente = function () { var d = estado(); return !!(d && d.falta && !recusou(d.falta)); };

  function montar() {
    if (raiz) return raiz;
    var css = document.createElement('style');
    css.textContent = '.tp-pcc{position:fixed;z-index:2147483000;left:50%;bottom:16px;width:min(100% - 24px,380px);transform:translate(-50%,16px);opacity:0;display:flex;align-items:flex-start;gap:12px;padding:14px 16px 14px 14px;border-radius:16px;background:#222F28;color:#F1F0EB;box-shadow:0 10px 30px rgba(34,47,40,.28);font-family:var(--tp-body-font,"Host Grotesk",ui-sans-serif,system-ui,sans-serif);transition:opacity .22s ease,transform .22s ease}'
      + '.tp-pcc[hidden]{display:none}.tp-pcc.is-aberto{opacity:1;transform:translate(-50%,0)}'
      + '@media (min-width:750px){.tp-pcc{left:auto;right:20px;bottom:20px;transform:translateY(16px)}.tp-pcc.is-aberto{transform:translateY(0)}}'
      + '.tp-pcc__img{flex:0 0 auto;width:56px;height:56px;border-radius:12px;object-fit:cover;background:rgba(255,170,153,.18)}'
      + '.tp-pcc__corpo{flex:1 1 auto;min-width:0}.tp-pcc__eyebrow{margin:0 0 2px;font-size:1.05rem;letter-spacing:.1em;text-transform:uppercase;color:#FFAA99;font-weight:600}'
      + '.tp-pcc__titulo{margin:0 0 4px;font-size:1.45rem;line-height:1.3;font-weight:600}.tp-pcc__titulo b{color:#FFAA99;font-weight:700}'
      + '.tp-pcc__chips{display:flex;flex-wrap:wrap;gap:6px;margin:0 0 10px}'
      + '.tp-pcc__chip{display:inline-flex;align-items:center;padding:4px 9px;border-radius:999px;border:1px solid rgba(241,240,235,.35);font-size:1.1rem;font-weight:600;letter-spacing:.02em}'
      + '.tp-pcc__chip--coral{border-color:#FFAA99;background:#FFAA99;color:#222F28}'
      + '.tp-pcc__acoes{display:flex;align-items:center;gap:14px;flex-wrap:wrap}'
      + '.tp-pcc__sim{display:inline-flex;align-items:center;padding:9px 14px;border-radius:999px;border:0;background:#FFAA99;color:#222F28;font:inherit;font-size:1.25rem;font-weight:700;cursor:pointer}'
      + '.tp-pcc__nao{border:0;background:transparent;padding:6px 2px;color:rgba(241,240,235,.75);font:inherit;font-size:1.2rem;text-decoration:underline;text-underline-offset:3px;cursor:pointer}';
    document.head.appendChild(css);
    var el = document.createElement('div');
    el.className = 'tp-pcc';
    el.setAttribute('role', 'status');
    el.setAttribute('data-tp-pcf', ''); /* o tp-quick-buy.js procura os dados dentro deste ancestral */
    el.hidden = true;
    el.innerHTML = '<img class="tp-pcc__img" data-pcc-img alt="" width="56" height="56" hidden>'
      + '<div class="tp-pcc__corpo"><p class="tp-pcc__eyebrow">Complete o biquíni</p>'
      + '<p class="tp-pcc__titulo" data-pcc-titulo></p>'
      + '<div class="tp-pcc__chips"><span class="tp-pcc__chip">+ <span data-pcc-preco></span></span><span class="tp-pcc__chip tp-pcc__chip--coral">Saquinho de Viagem grátis</span></div>'
      + '<div class="tp-pcc__acoes"><button type="button" class="tp-pcc__sim" data-pcc-sim data-tp-qb-open></button><button type="button" class="tp-pcc__nao" data-pcc-nao>Não, obrigada</button></div></div>'
      + '<script type="application/json" class="tp-pcf__data">null</script>'
      + '<script type="application/json" class="tp-pcf__versao-data">null</script>';
    document.body.appendChild(el);
    el.querySelector('[data-pcc-nao]').addEventListener('click', function () { var d = estado(); marcarRecusa(d && d.falta); fechar(); });
    /* O clique em "Escolher" é tratado pelo tp-quick-buy.js (delegação no document); aqui só fecha o cartão. */
    el.querySelector('[data-pcc-sim]').addEventListener('click', function () { setTimeout(fechar, 50); });
    window.addEventListener('resize', posicionar);
    raiz = el;
    return el;
  }
  function posicionar() {
    if (!raiz) return;
    if (window.innerWidth < 750) { raiz.style.right = ''; return; }
    var cd = document.querySelector('cart-drawer.active, cart-drawer[open]');
    var painel = cd && (cd.querySelector('[class*="drawer__inner"]') || cd.firstElementChild);
    var r = painel && painel.getBoundingClientRect();
    raiz.style.right = (r && r.width > 0 && r.width < window.innerWidth - 100) ? (window.innerWidth - r.left + 16) + 'px' : '';
  }
  function fechar() {
    if (!raiz || raiz.hidden) return;
    var estavaAberto = raiz.classList.contains('is-aberto');
    raiz.classList.remove('is-aberto');
    var el = raiz;
    setTimeout(function () { if (!el.classList.contains('is-aberto')) el.hidden = true; }, 240);
    if (estavaAberto) avisar(false);
  }
  function bloqueado() {
    var h = document.documentElement.classList;
    return h.contains('tp-roleta-open') || h.contains('tp-pg-open') || h.contains('tp-pt-open') || h.contains('tp-pe-open');
  }
  function popupAberto() { var qb = document.querySelector('tp-quick-buy'); return !!(qb && qb.classList.contains('is-open')); }

  function decidir() {
    var d = estado();
    if (!d || !d.falta || recusou(d.falta) || !gavetaAberta() || bloqueado() || popupAberto()) { fechar(); return; }
    var box = montar();
    var peca = d.falta === 'top' ? 'o top' : 'a calcinha';
    box.querySelector('[data-pcc-titulo]').innerHTML = 'Falta <b>' + peca + '</b> do seu biquíni';
    box.querySelector('[data-pcc-preco]').textContent = d.precoTexto || '';
    box.querySelector('[data-pcc-sim]').textContent = d.falta === 'top' ? 'Escolher o top' : 'Escolher a calcinha';
    var img = box.querySelector('[data-pcc-img]');
    if (d.imagem) { img.src = d.imagem; img.hidden = false; } else img.hidden = true;
    /* Dados de compra rápida da peça que falta, para o pop-up abrir nela. */
    box.querySelector('.tp-pcf__data').textContent = JSON.stringify(d.qb || null);
    box.querySelector('.tp-pcf__versao-data').textContent = JSON.stringify(d.versao || null);
    var jaAberto = box.classList.contains('is-aberto');
    if (box.hidden) { box.hidden = false; void box.offsetWidth; }
    box.classList.add('is-aberto');
    posicionar();
    if (!jaAberto) avisar(true);
  }

  function mudou() {
    var el = document.querySelector('[data-tp-praia-conjunto]');
    if (!el) return visto !== null ? ((visto = null), true) : false;
    var txt = el.textContent;
    if (el === visto && txt === vistoTxt) return false;
    visto = el; vistoTxt = txt;
    return true;
  }
  function agendar() { clearTimeout(timer); timer = setTimeout(decidir, 120); }
  function iniciar() {
    mudou();
    decidir();
    var gaveta = document.getElementById('CartDrawer');
    if (gaveta && window.MutationObserver) new MutationObserver(function () { if (mudou()) agendar(); }).observe(gaveta, { childList: true, subtree: true });
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) new MutationObserver(function () { agendar(); }).observe(cd, { attributes: true, attributeFilter: ['class', 'open'] });
    var qb = document.querySelector('tp-quick-buy');
    if (qb && window.MutationObserver) new MutationObserver(function () { agendar(); }).observe(qb, { attributes: true, attributeFilter: ['class'] });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { try { subscribe(PUB_SUB_EVENTS.cartUpdate, agendar); } catch (e) {} }
    if (window.MutationObserver) new MutationObserver(function () { agendar(); }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
